import type { ICatalog, ILocalizedText } from '@platform/core/types';
import type { IBuilderType } from './IBuilderType';

/**
 * Назва типу запису в конструкторі як «модуль» прототипу v4: головний тип — назва модуля в просторі (каталог, з перейменуванням простору),
 * дочірній — назва типу з каталогу простору (злита з налаштуваннями), інакше з визначення. Чиста функція.
 */
export function builderTypeName(row: IBuilderType, catalog: ICatalog | undefined, label: (text: ILocalizedText | null | undefined) => string): string {
  const summary = catalog?.modules.find((m) => m.key === row.def.module.key);
  if (row.rt.main) return label(summary?.name) || label(row.def.module.name);
  return label(summary?.recordTypes.find((r) => r.key === row.rt.key)?.name) || label(row.rt.name);
}
